import {Box, Divider as MuiDivider, styled} from '@mui/material';

export const Modal = styled(Box)(({open, theme}) => {
  return {
    display: open ? 'flex' : 'none',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: theme.zIndex.modal,
    backgroundColor: theme.vars.palette.grey[900],
    color: theme.vars.palette.text.primary,
  };
});

export const Drawer = styled(Box)(({theme}) => ({
  width: 360,
  backgroundColor: theme.vars.palette.grey[800],
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
}));

export const RightFrame = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
});

export const Divider = styled(MuiDivider)(({theme}) => ({
  backgroundColor: theme.vars.palette.grey[900],
  height: 2,
}));

export const MapParent = styled(Box)(({theme}) => ({
  position: 'relative',
  flex: 1,
  margin: '20px',
  borderRadius: '20px',
  overflow: 'hidden',
  backgroundColor: theme.vars.palette.grey[600],
}));
